/// <amd-module name="VSS/Redux/Utils/CreateShallowCompareSelector" />
import * as Reselect from "Reselect";
import { shallowCompare } from "VSS/Core/Util/Object";

export const createShallowCompareSelector = Reselect.createSelectorCreator(Reselect.defaultMemoize, shallowCompare);
